import { Grid, Typography } from "@mui/material"
import { MAX_EMAIL_LENGTH } from "../../../../constants/inputValidationDefaults"

import { FormikTextField } from "../../forms/Formik"
import { LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"
import type {
    PrivateCompanyDetailsFormValues,
    PrivatePersonDetailsFormValues,
    PublicInstitutionDetailsFormValues,
} from "../billReceiverTypes"

type DetailsUserInfoType =
    | PrivatePersonDetailsFormValues
    | PublicInstitutionDetailsFormValues
    | PrivateCompanyDetailsFormValues

export function DetailsContactFormSection() {
    return (
        <>
            <LocalizedStrict id="bill-receivers-form-contact-person">
                <Typography variant="subtitle1" textAlign="start">
                    Contact person:
                </Typography>
            </LocalizedStrict>
            <LocalizedStrict id="bill-receivers-form-label-contact-person" attrs={{ label: true }}>
                <FormikTextField<DetailsUserInfoType> name="contactPerson" label="Contact person" fullWidth />
            </LocalizedStrict>
            <Grid container flexWrap="nowrap" gap="1.25rem">
                <Grid item xs={6}>
                    <LocalizedStrict id="bill-receivers-form-label-email" attrs={{ label: true }}>
                        <FormikTextField<DetailsUserInfoType> name="email" label="Email" fullWidth maxLength={MAX_EMAIL_LENGTH} />
                    </LocalizedStrict>
                </Grid>
                <Grid item xs={6}>
                    <LocalizedStrict id="bill-receivers-form-label-telephone" attrs={{ label: true }}>
                        <FormikTextField<DetailsUserInfoType> name="telephone" label="Telephone" fullWidth />
                    </LocalizedStrict>
                </Grid>
            </Grid>
        </>
    )
}
